// src/pages/Home.tsx
import React, { useState } from 'react';
import DocumentForm from '../components/DocumentForm.tsx';
import DocumentView from '../components/DocumentView.tsx';
import { mockDocuments } from '../data/mockDocuments.ts';
import { DocumentData } from '../types/Document.ts';

const Home: React.FC = () => {
  const [documents, setDocuments] = useState<DocumentData[]>(mockDocuments);

  const handleGenerate = (newDoc: DocumentData) => {
    setDocuments([newDoc, ...documents]);
  };

  return (
    <div style={{margin: '20px'}}>
      <DocumentForm onGenerate={handleGenerate} />
      {documents.map((doc) => (
        <DocumentView key={doc.id} document={doc} />
      ))}
    </div>
  );
};

export default Home;
